import styled from 'styled-components';
import {
  pb, px, mt, pl, py, m, p, pr, pt, my
} from 'styled-components-spacing';
import breakpoint from 'styled-components-breakpoint';
import theme from '@lib/theme';
import Grid from 'styled-components-grid';

export const StyledGridWrapper = styled(Grid)`
  ${p(2)};
  ${breakpoint('mobile', 'tablet')`
  ${p(0)};
  `};
`;
export const StyledGridUnit = styled(Grid.Unit)``;


export const StyledTopSectionWrapper = styled(Grid)``;

export const StyledTopImageGridWapper = styled(Grid.Unit)``;
export const StyledTopImageWrapper = styled.div`
  ${p(3)};
  img {
    width: 100%;
  }
`;

export const StyledTopImagesCarousel = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const StyledTopCarouselImage = styled.div`
  ${p(2)};
  img {
    height: 100%;
    max-width: 100px;
    width: 100%;
  }
`;

export const StyledTopTextGridWapper = styled(Grid.Unit)`
  ${p(3)};
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
`;

export const StyledTitleMain = styled.div`
  color: ${theme.colors.darkGray};
  font-size: 30px;
  font-weight: bold;
`;

export const StyledLocationWrapper = styled.div`
  ${py(2)};
  display: flex;
  flex-direction: row;
`;

export const StyledLocationIconWrapper = styled.div`
  svg {
    height: 20px;
    width: 20px;
  }
`;

export const StyledLocationText = styled.div`
  color: ${theme.colors.mediumGray};
  font-size: 20px;
  font-weight: bold;
`;

export const StyledSubtitle = styled.div`
  color: ${theme.colors.mediumGray};
  font-size: 30px;
  font-weight: bold;
  ${pb(2)};
`;

export const StyledFacilityCardsWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  max-width: 100%;
`;

export const StyledFacilityCards = styled.div`
  ${p(2)};
  ${m(2)};
  height: 50px;
  width: 100%;
  border: 1px solid transparent;
  box-shadow: 0 3px 5px 0;
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: space-evenly;
`;

export const StyledFacilityCardsTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  max-width: 100%;
  align-items: center;
  justify-content: center;
  ${pl(1)};
`;

export const StyledFacilityCardsTitle = styled.div`
  color: ${theme.colors.mediumGray};
  text-align: center;
`;

export const StyledFacilityCardsSubtitle = styled.div`
  color: ${theme.colors.logoBlue};
`;

export const StyledPriceWrapper = styled.div`
  display: flex;
  flex-direction: row;
  ${py(2)};
  font-weight: bold;
  align-items: center;
  justify-content: space-between;
`;

export const StyledActualPriceWrapper = styled.div`
  font-size: 22px;
  text-decoration: line-through;
  color: ${theme.colors.mediumGray};
`;

export const StyledFinalPriceWrapper = styled.div`
  font-size: 28px;
  color: ${theme.colors.logoBlue};
`;

export const StyledSaveWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  svg {
    ${p(1)};
    width: 20px;
    height: 100%;
  }
`;

export const StyledSaveText = styled.div``;
export const StyledSaveTitle = styled.div`
  font-size: 20px;
  color: ${theme.colors.mediumGray};
  ${pb(2)};
`;
export const StyledSaveSubtitle = styled.div`
  font-size: 18px;
  color: ${theme.colors.logoBlue};
`;

export const StyledBookButton = styled.button`
  color: ${theme.colors.white};
  width: fit-content;
  font-size: 24px;
  ${px(4)};
  background-color: ${theme.colors.logoBlue};
  border: none;
  border-radius: 8px;
  outline: none;
  margin: 0 auto;
  ${py(2)};
`;

export const StyledBookText = styled.div`
  font-size: 12px;
  text-align: center;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  max-width: 400px;
  ${px(4)};
  ${py(2)};
  margin: 0 auto;
`;

export const StyledDoctorsCardWrapper = styled.div`
  ${m(2)};
  ${p(3)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid transparent;
  box-shadow: inset 0 0 10px ${theme.colors.mediumGray};
  border-radius: 8px;
`;

export const StyledCardsLeftWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const StyledCardsRightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const StyledDoctorsCardTitle = styled.div`
  margin: 0 auto;
  ${p(1)};
  svg {
    ${pr(1)};
    width: 25px;
    height: 100%;
  }
  color: ${theme.colors.newThemeDarkBlue};
  font-weight: bold;
  font-size: 25px;
`;

export const StyledDoctorsNameTitle = styled.div`
  color: ${theme.colors.newThemeDarkBlue};
  font-weight: bold;
  font-size: 18px;
  ${p(1)};
`;
export const StyledDoctorsNameSubtitle = styled.div`
  color: ${theme.colors.mediumGray};
  font-weight: bold;
  ${p(1)};
  font-size: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  svg {
    height: 20px;
    width: 20px;
    ${pr(1)};
  }
`;
export const StyledDoctorsHospitalName = styled.div`
  color: ${theme.colors.mediumGray};
  font-size: 12px;
  ${p(1)};
  svg {
    ${pr(1)};
    color: ${theme.colors.mediumGray};
    width: 12px;
  }
`;

export const StyledCardImage = styled.div`
  ${p(3)};
  display: flex;
  flex-direction: row;
  justify-content: center;
  max-width: 100%;
  border: 2px solid transparent;
  img {
    width: 60%;
    min-width: 150px;
    aspect-ratio: 1/1;
    border-radius: 100%;
  }
`;

export const StyledDoctorsHeadings = styled.div`
  color: ${theme.colors.newThemeDarkBlue};
  font-weight: bold;
  font-size: 22px;
  ${p(3)};
`;

export const StyledSepratorGray = styled.hr`
  color: ${theme.colors.mediumGray};
  width: 80%;
`;

export const StyledViewProfileButton = styled.button`
  ${m(3)};
  svg {
    ${pl(1)};
    width: 14px;
  }
  border: 1px solid ${theme.colors.logoBlue};
  border-radius: 6px;
  max-width: max-content;
  ${p(2)};
  color: ${theme.colors.logoBlue};
  background-color: transparent;
  display: flex;
  flex-direction: row;
`;

export const StyledHospitalCardWrapper = styled.div`
  background-color: ${theme.colors.greyBlue10};
  ${m(2)};
  ${p(3)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid transparent;
  box-shadow: inset 0 0 10px ${theme.colors.mediumGray};
  border-radius: 8px;
`;

export const StyledHospitalCardTitle = styled.div`
  color: ${theme.colors.mediumGray};
  align-self: start;
  font-size: 22px;
  ${pt(4)};
  ${pb(2)};
  ${px(3)};
  svg {
    ${pl(1)};
    width: 20px;
  }
`;
export const StyledHospitalCardDescription = styled.div`
  color: ${theme.colors.mediumGray};
  font-size: 22px;
  ${p(3)};
  line-height: 1.8rem;
`;

export const StyledHeadlines = styled.div`
  color: ${theme.colors.mediumGray};
  font-size: 25px;
  font-weight: bold;
  ${px(2)};
  ${py(3)};
  ${my(2)};
`;

export const StyledFormWrapper = styled.div`
  top: 100px;
  position: sticky;
`;

export const StyledComponentWrappers = styled.div`
  ${pt(4)}
  ${mt(1)};
`;
